import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "icn-day-of-week-picker",
  templateUrl: "./day-of-week-picker.component.html",
  styleUrls: ["./day-of-week-picker.component.scss"],
})
export class DayOfWeekPickerComponent {
  @Input()
  overrideStyle: { [key: string]: string } = null;
  @Input()
  selectedDay: number = 0;

  @Output()
  onChange = new EventEmitter<number>();

  dayOfWeeks: Array<{ id: number; name: string }>;
  constructor() {
    this.dayOfWeeks = [
      { id: 0, name: "Sunday" },
      { id: 1, name: "Monday" },
      { id: 2, name: "Tuesday" },
      { id: 3, name: "Wednesday" },
      { id: 4, name: "Thursday" },
      { id: 5, name: "Friday" },
      { id: 6, name: "Saturday" },
    ];
  }
}
